// extracted by mini-css-extract-plugin
module.exports = {"new":"view-default_new_22Zi6","dangerous":"view-default_dangerous_1IsCc"};